import { useTypedQuery } from "hooks";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Tag } from "models";

const getTagsOptions = (tags: Tag[]) => tags.map(tag => ({ key: tag.id, value: tag.id, text: tag.name }));

export const useTagsQuery = () =>
  useTypedQuery({
    queryKey: ChecklistsDashboardQueryKeys.tags,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.get(endpoint, baseUrl)).data.tags ?? [],
    select: getTagsOptions
  });
